// Consentement cookies : bandeau Didomi de Pandacraft (même notice que www.pandacraft.com et la boutique).
// Les cookies de choix sont posés sur .pandacraft.com : un choix fait sur la LP vaut sur le tunnel d'abonnement.
// onConsent(tracking, cb) appelle cb({ ga4, meta }) quand Didomi est prêt, puis à chaque changement de choix.
// Sans clé Didomi (config.tracking.didomiKey = null), aucun tag n'est autorisé.

/** Bouchon IAB TCF (__tcfapi) + chargeur Didomi : snippet officiel, identique à celui de pandacraft.com. */
function loadDidomi(key) {
  /* eslint-disable */
  window.gdprAppliesGlobally=true;(function(){function a(e){if(!window.frames[e]){if(document.body&&document.body.firstChild){var t=document.body;var n=document.createElement("iframe");n.style.display="none";n.name=e;n.title=e;t.insertBefore(n,t.firstChild)}
  else{setTimeout(function(){a(e)},5)}}}function e(n,r,o,c,s){function e(e,t,n,a){if(typeof n!=="function"){return}if(!window[r]){window[r]=[]}var i=false;if(s){i=s(e,t,n)}if(!i){window[r].push({command:e,parameter:t,callback:n,version:a})}}e.stub=true;function t(a){if(!window[n]||window[n].stub!==true){return}if(!a.data){return}
  var i=typeof a.data==="string";var e;try{e=i?JSON.parse(a.data):a.data}catch(t){return}if(e[o]){var r=e[o];window[n](r.command,r.parameter,function(e,t){var n={};n[c]={returnValue:e,success:t,callId:r.callId};a.source.postMessage(i?JSON.stringify(n):n,"*")},r.version)}}
  if(typeof window[n]!=="function"){window[n]=e;if(window.addEventListener){window.addEventListener("message",t,false)}else{window.attachEvent("onmessage",t)}}}e("__tcfapi","__tcfapiBuffer","__tcfapiCall","__tcfapiReturn");a("__tcfapiLocator");(function(e){
  var t=document.createElement("script");t.id="spcloader";t.type="text/javascript";t.async=true;t.src="https://sdk.privacy-center.org/"+e+"/loader.js?target="+document.location.hostname;t.charset="utf-8";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n)})(key)})();
  /* eslint-enable */
}

/** État réel des vendors (getCurrentUserStatus indexe les vendors perso sans le préfixe « c: »). */
function status(Didomi, vendors) {
  const list = Didomi.getCurrentUserStatus().vendors || {};
  const ok = (id) => Boolean(id) && (list[id] || list[id.replace(/^c:/, "")])?.enabled === true;
  return { ga4: ok(vendors.ga4), meta: ok(vendors.meta) };
}

export function onConsent(tracking, cb) {
  const { didomiKey, didomiVendors = {} } = tracking;
  if (!didomiKey) {
    cb({ ga4: false, meta: false });
    return;
  }
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiEventListeners = window.didomiEventListeners || [];
  window.didomiOnReady.push((Didomi) => cb(status(Didomi, didomiVendors)));
  window.didomiEventListeners.push({
    event: "consent.changed",
    listener: () => { if (window.Didomi) cb(status(window.Didomi, didomiVendors)); }
  });
  loadDidomi(didomiKey);
}
